import { render } from "./HerbsList.vue?vue&type=template&id=67f7f285&scoped=true"
import script from "./HerbsList.vue?vue&type=script&lang=js"
export * from "./HerbsList.vue?vue&type=script&lang=js"

import "./HerbsList.vue?vue&type=style&index=0&id=67f7f285&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.106.2_@swc+core@1.3.96_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f7f285"]])

export default __exports__